import { icon } from "../lib/icons";

export function bookingModalHTML(): string {
  return `
<template x-if="$store.ui.bookingMode">
  <div class="modal-backdrop" @click="$store.ui.close()" @keydown.escape.window="$store.ui.close()" x-data="bookingModal()">
    <div class="modal" style="max-width: 720px" role="dialog" aria-modal="true" aria-labelledby="booking-modal-title" @click.stop
      x-init="window.autoFocus($el)"
      @keydown.tab="window.trapTab($event, $el, false)"
      @keydown.shift.tab="window.trapTab($event, $el, true)">
      <div class="modal-h">
        <h2 id="booking-modal-title" x-text="isView ? 'Booking detail' : 'New booking'"></h2>
        <span class="muted mono" style="margin-left: 10px; font-size: 11px">
          #<span x-text="b.id.slice(0, 8)"></span>
        </span>
        <button class="btn-ghost btn btn-icon" style="margin-left: auto" type="button"
          aria-label="Close booking" @click="$store.ui.close()">
          ${icon("x", 14)}
        </button>
      </div>

      <div class="modal-body bk-form">
        <div class="grid-2">
          <label class="field">
            <span class="field-label">Lesson</span>
            <select class="select" :disabled="isView" x-model="b.lessonId">
              <template x-for="l in $store.board.lookups.lessons" :key="l.id">
                <option :value="l.id" x-text="l.name"></option>
              </template>
            </select>
          </label>
          <label class="field">
            <span class="field-label">Aircraft</span>
            <select class="select" :disabled="isView" x-model="b.aircraftId">
              <option value="">None (classroom)</option>
              <template x-for="a in $store.board.lookups.aircraft" :key="a.id">
                <option :value="a.id" x-text="\`\${a.tail} · \${a.model}\`"></option>
              </template>
            </select>
          </label>
        </div>
        <div class="grid-2">
          <label class="field">
            <span class="field-label">Student</span>
            <select class="select" :disabled="isView" x-model="b.studentId">
              <option value="">None</option>
              <template x-for="u in $store.board.lookups.profiles.filter(p => p.role === 'Student')" :key="u.id">
                <option :value="u.id" x-text="u.name"></option>
              </template>
            </select>
          </label>
          <label class="field">
            <span class="field-label">Instructor</span>
            <select class="select" :disabled="isView" x-model="b.instructorId">
              <option value="">None (solo)</option>
              <template x-for="u in $store.board.lookups.profiles.filter(p => p.role.includes('Instructor'))" :key="u.id">
                <option :value="u.id" x-text="u.name"></option>
              </template>
            </select>
          </label>
        </div>
        <div class="grid-2">
          <label class="field">
            <span class="field-label">Start</span>
            <input type="time" class="input mono" :disabled="isView" x-model="b.start" />
          </label>
          <label class="field">
            <span class="field-label">End</span>
            <input type="time" class="input mono" :disabled="isView" x-model="b.end" />
          </label>
        </div>
        <label class="field">
          <span class="field-label">Notes</span>
          <textarea class="textarea" rows="2" :disabled="isView" x-model="b.notes"
            placeholder="Optional notes for the dispatcher…"></textarea>
        </label>

        <template x-if="blockers.length > 0">
          <div class="bk-warn-list block">
            <h3 class="bk-warn-h">${icon("x", 13)} Blocker · cannot save</h3>
            <ul>
              <template x-for="w in blockers" :key="w.title + w.detail">
                <li class="bk-warn-item">
                  <span class="chip bad"><span class="chip-dot"></span>conflict</span>
                  <span><strong x-text="w.title + '.'"></strong> <span class="detail" x-text="w.detail"></span></span>
                </li>
              </template>
            </ul>
          </div>
        </template>

        <template x-if="softWarns.length > 0">
          <div class="bk-warn-list">
            <h3 class="bk-warn-h">${icon("warn", 13)} <span x-text="softWarns.length + ' warning' + (softWarns.length > 1 ? 's' : '') + ' · save allowed'"></span></h3>
            <ul>
              <template x-for="w in softWarns" :key="w.title + w.detail">
                <li class="bk-warn-item">
                  <span class="chip warning"><span class="chip-dot"></span><span x-text="w.kind"></span></span>
                  <span><strong x-text="w.title + '.'"></strong> <span class="detail" x-text="w.detail"></span></span>
                </li>
              </template>
            </ul>
          </div>
        </template>

        <template x-if="warnings.length === 0">
          <div style="padding: 10px 12px; border: 1px solid var(--ok-100); background: var(--ok-50); border-radius: var(--radius-sm); color: var(--ok-700); font-size: 13px; display: flex; gap: 8px; align-items: center">
            ${icon("check", 14)} No conflicts or warnings detected. Clean booking.
          </div>
        </template>
      </div>

      <div class="modal-foot">
        <template x-if="isView && b.status !== 'canceled' && b.status !== 'completed'">
          <button type="button" class="btn btn-danger"
            :class="confirmingCancel ? 'confirming' : ''"
            @click="requestCancel()"
            x-text="confirmingCancel ? 'Click again to confirm' : 'Cancel booking'"></button>
        </template>
        <button type="button" class="btn" @click="$store.ui.close()" x-text="isView ? 'Close' : 'Discard'"></button>
        <template x-if="!isView">
          <button type="button" class="btn btn-primary" :disabled="blockers.length > 0" @click="save()"
            x-text="blockers.length > 0 ? 'Resolve blocker to save' : softWarns.length > 0 ? 'Save with warnings' : 'Save booking'">
          </button>
        </template>
      </div>
    </div>
  </div>
</template>
`;
}
